import React from "react";
import { RouterProvider } from "react-router-dom";
import publicList from "./routePublicData";

const PublicRoute: React.FC = () => {
  return (
    <>
      <RouterProvider
        future={{
          v7_startTransition: true,
        }}
        router={publicList}
      ></RouterProvider>
    </>
  );
};

export default PublicRoute;
